class TileSource {
  constructor(baseUrl) {
    this.baseUrl = baseUrl.replace(/\/+$/, '');
  }

  addRegionSource(map, config) {
    if (map.getSource(config.SOURCE_ID)) return;
    map.addSource(config.SOURCE_ID, {
      type: 'vector',
      url: `${this.baseUrl}/${config.SOURCE_PREFIX}`,
    });
  }

  addRegionLayers(map, config) {
    const sourceId = config.SOURCE_ID;
    const sourceLayer = config.SOURCE_LAYER;

    if (!map.getLayer(config.LAYER_ID)) {
      map.addLayer({
        id: config.LAYER_ID,
        type: config.LAYER_TYPE,
        source: sourceId,
        'source-layer': sourceLayer,
        paint: {
          [config.COLOR_PARAM]: config.COLOR,
          [config.OPACITY_PARAM]: config.OPACITY,
        },
      });
    }

    if (!map.getLayer(config.OUTLINE_LAYER_ID)) {
      map.addLayer({
        id: config.OUTLINE_LAYER_ID,
        type: config.OUTLINE_LAYER_TYPE,
        source: sourceId,
        'source-layer': sourceLayer,
        paint: {
          [config.OUTLINE_COLOR_PARAM]: config.OUTLINE_COLOR,
        },
      });
    }
  }

  addImpactSource(map, config, levelName) {
    if (map.getSource(config.SOURCE_ID)) return;
    map.addSource(config.SOURCE_ID, {
      type: 'vector',
      url: `${this.baseUrl}/${config.SOURCE_PREFIX}_${levelName}`,
    });
  }

  addImpactLayer(map, config, sourceLayer) {
    if (map.getLayer(config.LAYER_ID)) {
      map.removeLayer(config.LAYER_ID);
    }

    map.addLayer({
      id: config.LAYER_ID,
      type: config.LAYER_TYPE,
      source: config.SOURCE_ID,
      'source-layer': sourceLayer,
      paint: {
        [config.COLOR_PARAM]: config.COLOR,
        [config.OPACITY_PARAM]: config.OPACITY,
      },
    });
  }

  removeLayer(map, layerId) {
    if (map.getLayer(layerId)) {
      map.removeLayer(layerId);
    }
  }

  removeSource(map, sourceId) {
    if (map.getSource(sourceId)) {
      map.removeSource(sourceId);
    }
  }

  removeRegion(map, config) {
    this.removeLayer(map, config.LAYER_ID);
    this.removeLayer(map, config.OUTLINE_LAYER_ID);
    this.removeSource(map, config.SOURCE_ID);
  }

  removeImpact(map, config) {
    this.removeLayer(map, config.LAYER_ID);
    this.removeSource(map, config.SOURCE_ID);
  }
}

export default TileSource;
